import { Injectable, Injector } from '@angular/core';
import { ApiService } from '@modules/shared/services/api.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { resolveDebt } from '@modules/shared/resolvers/resolveDebt';
import { filter, forEach, pathEq, pipe, pluck, propEq, reject } from 'ramda';

export const addSiblingsIds = (debts: Debt[]) => {
    let listUpdated = [];
    forEach((debt: Debt) => {
        if (!debt.debtInfo.resourceId) {
            listUpdated = [...listUpdated, debt];
            return;
        }
        debt.siblingsIds = pipe(
            filter(pathEq(['info', 'resourceId'], debt.debtInfo.resourceId)),
            reject(propEq('id', debt.id)),
            pluck('id')
        )(debts);
        listUpdated = [...listUpdated, debt];
    }, debts);
    return listUpdated;
};

@Injectable()
export class DebtService extends ApiService {
    constructor(protected injector: Injector) {
        super(injector);
    }

    getDebts(): Observable<Debt[]> {
        return this.get<Debt[]>('debts').pipe(map((debts) => addSiblingsIds(debts.map(resolveDebt))));
    }

    getCommission() {
        return this.get('payment_comissions').pipe(
            catchError(() => {
                console.error('An error occurred getting the commissions');
                return of(null);
            })
        );
    }
}
